<style>
.v-label,
.v-select__selections {
  font-size: 12px !important;
}
</style>
<template>
  <div style="height: 85%">
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout>
      <v-flex xs7>
        <v-layout
          class="table--first-row"
          row
          wrap
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              @click="show('addVideoInspectionCardModal')"
              v-if="$can('read', 'videos_edit')"
              class="table__btn--green"
            >add_circle</v-icon>
            <p
              class="caption"
              @click="show('addVideoInspectionCardModal')"
            >DODAJ INSPEKCJĘ WIDEO</p>
            <v-icon
              class="table__btn--blue table__btn--padding"
              v-show="selectedRow"
              @click="openVideoCard"
            >note</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="openVideoCard"
            >OTWÓRZ KARTĘ</p>
            <v-icon
              class="table__btn--red table__btn--padding"
              v-show="selectedRow"
              @click="removeRow"
            >delete</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="removeRow"
            >USUŃ</p>
          </v-flex>
          <v-spacer />
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
              class="table__btn--blue"
            >cloud_download</v-icon>
            <p
              class="caption"
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
            >POBIERZ REJESTR</p>
            <v-icon
              class="table__btn--padding"
              v-show="selectedRow"
              @click="zoomToGeometry"
            >zoom_in</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="zoomToGeometry"
            >PRZYBLIŻ</p>
          </v-flex>
          <v-spacer />
        </v-layout>
      </v-flex>
      <v-flex
        xs5
        class="table__wrapper--center table__wrapper--filter"
      >
        <v-layout
          align-right
          justify-end
        >
          <v-select
            :items="inspectionTypes"
            label="Filtr: Typ"
            v-model="filterStatus"
            hide-details
            clearable
            @change="filterByStatus(filterStatus)"
            style="padding-right:10px;"
          ></v-select>
          <v-text-field
            type="text"
            v-model="filter"
            placeholder="Treść filtra"
            clearable
            :hint="numberFiltered + '/' + numberAll"
            persistent-hint
            filled
          >
          </v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>
    <ag-grid-vue
      class="ag-theme-balham"
      :gridOptions="gridOptions"
      style="height: 90%"
    ></ag-grid-vue>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import ExportTableData from "../../shared/ExportTableData";

export default {
  name: "App",
  data: () => ({
    date_now: new Date(),
    filter: "",
    numberAll: '0', //hint z textfielda wymaga, by wartość była typu string
    numberFiltered: '0', //hint z textfielda wymaga, by wartość była typu string
    selectedRow: undefined,
    statusFilter: '',
    filterStatus: '',
    tableTitle: "videoInspectionsTable",
    inspectionTypes: ['bezplanowa', 'gwarancyjna', 'okresowa', 'powykonawcza']
  }),
  components: {
    AgGridVue,
    ExportTableData,
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    }
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    gridOptions() {
      let gridOptions = {
        rowData: this.loadData(),
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        onFilterChanged: this.filteredNumber,
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onSelectionChanged: this.onSelectionChanged,
        rowSelection: "single",
        context: {
          componentParent: this
        },
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          lessThan: "Mniejsza niż",
          greaterThan: "Większa niż",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        }
      };
      return gridOptions;
    },
    users() {
      return this.$store.getters.getUsersMap;
    },
    videoInspectionCards() {
      return this.$store.getters.getVideoInspectionCards;
    }
  },
  beforeMount() {
    this.columnDefs = [
      {headerName: "ID", field: "id", sort: "asc"},
      {
        headerName: "Data inspekcji",
        field: "properties.inspection_date",
        cellRenderer: date => {
          if(date.value != null) {
            return new Date(date.value).toLocaleString("pl-PL", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit"
            });
          }
        },
        filter: "agDateColumnFilter",
        filterParams: {
          comparator: (filterLocalDateAtMidnight, cellValue) => {
            if(!cellValue) return 0
            let date = new Date(cellValue);
            let dateString;
            let timeString;
            if (cellValue.includes('T')) {
              [dateString, timeString] = cellValue.split('T');
            } else {
              [dateString, timeString] = cellValue.split(' ');
            }
            var dateStringParts = dateString.split("-");
            // let timeStringParts = timeString.split(':')
            var day = Number(dateStringParts[2]);
            var month = Number(dateStringParts[1]) - 1;
            var year = Number(dateStringParts[0]);
            // TODO spróbować naprawić godziny i minuty
            // let hours = Number(timeStringParts[0])
            // let minutes = Number(timeStringParts[1])
            var cellDate = new Date(year, month, day);
            if(cellDate < filterLocalDateAtMidnight) {
              return -1;
            } else if(cellDate > filterLocalDateAtMidnight) {
              return 1;
            } else {
              return 0;
            }
          },
          browserDatePicker: true
        },
      },
      {headerName: "Adres", field: "properties.address"},
      {headerName: "Typ", field: "properties.inspection_type"},
      {
        headerName: "ID inspektora",
        field: "properties.inspector_id",
      },
      {headerName: "Opis", field: "properties.description"},
      {headerName: "Geometria", field: "properties.geometry", hide: true}
    ];
  },
  methods: {
    filterByStatus(value) {
      let statusFilter = this.gridOptions.api.getFilterInstance(
        "properties.inspection_type"
      );
      statusFilter.setModel({
        type: "equals",
        filter: value
      });
      this.gridOptions.api.onFilterChanged();
      this.filteredNumber();
    },
    filteredNumber() {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    loadData() {
      let payload = {
        attachments: true,
        pipes: false
      };
      this.$store.dispatch("getVideoInspectionCards", payload).then(success => {
        if(success) {
          this.numberAll = this.videoInspectionCards.length.toString();
          this.numberFiltered = this.numberAll;
          if(this.gridOptions.api) this.gridOptions.api.setRowData(this.videoInspectionCards);
        }
      });
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    onSelectionChanged() {
      this.selectedRow = this.gridOptions.api.getSelectedRows()[0];
      this.$root.$emit('removeMapLayer');
    },
    openVideoCard() {
      let payload = {
        object_id: this.selectedRow.id,
        object_type: 'video',
        limit: 5,
        events_count: true
      };
      this.$root.$emit('loadVideoInspection', this.selectedRow);
      this.$store.dispatch("getFeatureEvents", payload).then(() => {
        this.show("videoInspectionCardModal");
      })

    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    removeRow() {
      let oid = this.selectedRow.id;
      this.$emit("confDialogOpened", true);
      this.$modal.show("dialog", {
        title: "Usuwanie inspekcji wideo",
        text: "Czy na pewno chcesz inspekcję wideo?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              this.$store
                .dispatch("deleteVideoInspectionCard", oid)
                .then(success => {
                  if(success) {
                    this.$root.$emit(
                      "showSnackbar",
                      "success",
                      "Pomyślnie usunięto inspekcję wideo"
                    );
                    let selectedData = this.gridOptions.api.getSelectedRows();
                    this.gridOptions.api.updateRowData({remove: selectedData});
                    this.numberFiltered -= 1;
                    this.$store.dispatch("getVideoInspectionCards", {attachments: true, pipes: false});
                    this.$root.$emit('removeVideoLayer');
                  } else {
                    this.$root.$emit(
                      "showSnackbar",
                      "red",
                      "Podczas usuwania inspekcji wideo wystąpił błąd"
                    );
                  }
                });
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    zoomToGeometry() {
      this.$root.$emit('zoomToArea', [this.selectedRow.geometry.coordinates]);
      this.$root.$emit(
        "addMapLayer",
        [this.selectedRow.geometry, this.selectedRow.geometry.coordinates],
        "video"
      );
    }

  },
  mounted() {
    this.$root.$on("edited_video_inspection", this.loadData);
    this.$store.dispatch("getUsers").then(r => {
      this.$forceUpdate();
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/VideoInspectionsTable.vue